import { render, staticRenderFns } from "./DownloadTicket.vue?vue&type=template&id=70e9ff86&"
import script from "./DownloadTicket.vue?vue&type=script&lang=js&"
export * from "./DownloadTicket.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports